module.exports = __webpack_public_path__ + "f1a93ecb43f9bdb0e52b15fc97b44c73.png";